export default __webpack_public_path__ + "static/media/2020-plan-4.13ec1ed6.jpeg";